import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import { AlertaSimplesDialog } from '../alerta-simples';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-me-receita',
  templateUrl: './me-receita.component.html',
  styleUrls: ['./me-receita.component.css']
})
export class MeReceitaComponent implements OnInit {
  hideCL: boolean = false;
  dh: any = '';
  urlFoto: any = '';

  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService,  public dialog: MatDialog) { }

  ngOnInit() {
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/receitas/";
    //this.urlFoto = 'https://tamasappcdn.s3.sa-east-1.amazonaws.com/receitas/';
    this.getReceita(this.route.snapshot.paramMap.get('receita'));

  }


  getReceita(id: any) :void{

    let customParams = {
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      idreceita: id
    };
    this.tmaService.infoReceita(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.dh = qRes['receita'];
       
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Ocorreu um erro ao carregar as receitas", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }


  voltar() :void{
    // this._location.back();
    this.router.navigate(['me/receitas']);
  }





  


}
